/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientsSidePanelFilterContent.vue?vue&type=template&id=675b2483&scoped=true"
import script from "./PatientsSidePanelFilterContent.vue?vue&type=script&lang=js"
export * from "./PatientsSidePanelFilterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b2483",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675b2483')) {
      api.createRecord('675b2483', component.options)
    } else {
      api.reload('675b2483', component.options)
    }
    module.hot.accept("./PatientsSidePanelFilterContent.vue?vue&type=template&id=675b2483&scoped=true", function () {
      api.rerender('675b2483', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PatientsSidePanelFilterContent.vue"
export default component.exports